var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "versionLockout" } }, [
    _c("div", { staticClass: "center-parent" }, [
      _c("div", { staticClass: "dialog-box" }, [
        _c(
          "div",
          { staticClass: "icon" },
          [_c("v-icon", { attrs: { large: "" } }, [_vm._v("mdi-download")])],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "title" }, [_vm._v("UPDATE REQUIRED")]),
        _vm._v(" "),
        _c("div", { staticClass: "context large" }, [
          _vm._v(
            "This version of Vilio (" +
              _vm._s(_vm.version) +
              ") is no longer supported."
          )
        ]),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _vm.platform !== "web"
          ? _c("div", { staticClass: "context" }, [
              _vm._v("Please update your app via the\n        "),
              _vm.platform == "android"
                ? _c(
                    "span",
                    {
                      staticClass: "link main-text",
                      on: {
                        click: function($event) {
                          _vm.forceUpdateLink("android")
                        }
                      }
                    },
                    [_vm._v("Google Play Store")]
                  )
                : _vm._e(),
              _vm.platform
                ? _c(
                    "span",
                    {
                      staticClass: "link",
                      attrs: { "!": "android" },
                      on: {
                        click: function($event) {
                          _vm.forceUpdateLink("ios")
                        }
                      }
                    },
                    [_vm._v("Apple App Store")]
                  )
                : _vm._e(),
              _vm._v(".\n      ")
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.platform === "web"
          ? _c("div", { staticClass: "context" }, [
              _vm._v(
                "Please refresh your browser to get the latest version of Vilio."
              ),
              _c("br"),
              _c("br"),
              _vm._v("If you are still receiving this message, please try "),
              _c(
                "span",
                {
                  staticClass: "link",
                  on: {
                    click: function($event) {
                      _vm.forceUpdateLink("clearcache")
                    }
                  }
                },
                [_vm._v("clearing your cache.")]
              )
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b38cc20a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b38cc20a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VersionLockout.vue
// module id = 638
// module chunks = 4